import update_, { Draft } from "immer";

export type Mutable<A> = Draft<A>;
export namespace Mutable {
  export const update = update_;
}
